import React, { useState } from 'react';
import { Modal, DatePicker, Select as AntdSelect } from 'antd';
import { Form, Formik } from 'formik';
import FieldInput from '../../../../TopQualities/FieldInput';
import Select from '../../../../TopQualities/Select';
import StatusToggler from 'components/UI/Toggler/StatusToggler';
import * as Yup from 'yup';
import style from './style.module.scss';
import './issueResolutionModal.scss';
import UploadMediaWithS3 from 'components/HOCs/UploadMediaWithS3';
import DateFieldInput from '../../CustomComponents/DateFieldInput/DateFieldInput';
import SelectInput from '../../CustomComponents/SelectInput/SelectInput';
import FileInput from '../../CustomComponents/FileInput/FileInput';
import RadioFieldInput from '../../CustomComponents/RadioField/RadioFieldInput';
import AlertImg from '../../../../../../assets/images/communication/warning-2.svg';
import Toast from '../../CustomComponents/Toast/Toast';
import { get_service_endpoint } from 'ServiceEndpoints';
import axios from 'axios';
import { updateIssueStatus } from 'store/actions/IssuePanelActions';
import { connect } from 'react-redux';
import { ISSUE_STATUS, getFormattedTimestamp, formatToDateOnly } from '../constants';

const IssueResolutionModal = ({
  issueResolutionModalVisible,
  setIssueResolutionModalVisible,
  status = 10,
  record,
  updateIssueStatus,
  user,
  toastVisible,
  setToastVisible,
  setToastText,
  activeIssueData,
}) => {
  const [customerCreditNoteAvailable, setCutomerCreditNoteAvailable] = useState(false);
  const [refundInitiated, setRefundInitiated] = useState(false);
  const [supplierDocAvailable, setSupplierDocAvailable] = useState(false);
  const [showWarning,setShowWarning] = useState(false);
  const [supplierDocLabel, setSupplierDocLabel] = useState('Credit note');

  const initialValues = {
    customerCreditNoteAvailable: false,
    creditNoteNumber: null,
    creditNoteDate: null,
    creditNoteAmount: null,
    creditNoteUrl: null,

    refundInitiated: false,
    paymentMode: null,
    refundDate: null,
    refundAmount: null,
    utrRefNumber: null,
    refundDocUrl: null,

    supplierDocAvailable: false,
    supplierId: (record.supplierId.split(',').length > 1 ? 
     record?.issueStatus === ISSUE_STATUS.RETURN_INITIATED ?  record.supplierId.split(',')[1]: null 
     : record.supplierId.split(',')[0]),
    supplierName: (record.supplierName.split(',').length > 1 ? null : record.supplierId.split(',')[0]),
    supplierDocType: null,
    supplierDocNumber: null,
    supplierDocAmount: null,
    supplierDocDate: null,
    supplierDocUrl: null,
  };

  const validationSchema = Yup.object().shape({
    customerCreditNoteAvailable: Yup.boolean(),
    creditNoteNumber: Yup.string()
      .nullable()
      .when('customerCreditNoteAvailable', {
        is: true,
        then: (schema) => schema.required('Credit note number is required'),
      }),
    creditNoteDate: Yup.date()
      .nullable()
      .when('customerCreditNoteAvailable', {
        is: true,
        then: (schema) => schema.required('Credit note date is required'),
      }),
    creditNoteAmount: Yup.number()
      .nullable()
      .typeError('Credit note amount must be a number')
      .when('customerCreditNoteAvailable', {
        is: true,
        then: (schema) => schema
        .required('Credit note amount is required')
        .positive('Please enter a positive number'),
      }),
    creditNoteUrl: Yup.mixed()
      .nullable()
      .when('customerCreditNoteAvailable', {
        is: true,
        then: (schema) => schema.required(''),
      }),

    refundInitiated: Yup.boolean(),
    paymentMode: Yup.string()
      .nullable()
      .when('refundInitiated', {
        is: true,
        then: (schema) => schema.required('Payment mode is required'),
      }),
    refundDate: Yup.date()
      .nullable()
      .when('refundInitiated', {
        is: true,
        then: (schema) => schema.required('Refund date is required'),
      }),
    refundAmount: Yup.number()
      .nullable()
      .typeError('Refund amount must be a number')
      .when('refundInitiated', {
        is: true,
        then: (schema) => schema
        .required('Refund amount is required')
        .positive('Please enter a positive number'),
      }),
    utrRefNumber: Yup.string()
      .nullable()
      .when('refundInitiated', {
        is: true,
        then: (schema) => schema.required('UTR / Reference Number is required'),
      }),
    refundDocUrl: Yup.mixed()
      .nullable()
      .when('refundInitiated', {
        is: true,
        then: (schema) => schema.required(''),
      }),

    supplierDocAvailable: Yup.boolean(),
    supplierId: Yup.string()
      .nullable()
      .when('supplierDocAvailable', {
        is: true,
        then: (schema) => schema.required('Supplier is required'),
      }),
    supplierDocType: Yup.string()
      .nullable()
      .when('supplierDocAvailable', {
        is: true,
        then: (schema) => schema.required('Document type is required'),
      }),
    supplierDocNumber: Yup.string()
      .nullable()
      .when('supplierDocAvailable', {
        is: true,
        then: (schema) => schema.required('Supplier document number is required'),
      }),
    supplierDocDate: Yup.date()
      .nullable()
      .when('supplierDocAvailable', {
        is: true,
        then: (schema) => schema.required(''),
      }),
    supplierDocAmount: Yup.number()
      .nullable()
      .typeError('Amount must be a number')
      .when('supplierDocAvailable', {
        is: true,
        then: (schema) => schema
        .required('Supplier document amount is required')
        .positive('Please enter a positive number')
      }),
    supplierDocUrl: Yup.mixed()
      .nullable()
      .when('supplierDocAvailable', {
        is: true,
        then: (schema) => schema.required(''),
      }),
  });

  const validateInputs = (keyArray, values, errors) => {
    for (let key of keyArray) {
      if (!values[key] || errors[key]) return false;
    }
    return true;
  };

  const disableSubmitButton = (values, errors) => {
    const creditNoteKeys = [
      'creditNoteNumber',
      'creditNoteDate',
      'creditNoteAmount',
      'creditNoteUrl',
    ];
    const refundKeys = [
      'paymentMode',
      'refundDate',
      'refundAmount',
      'utrRefNumber',
      'refundDocUrl',
    ];
    const supplierDocKeys = [
      'supplierId',
      'supplierDocType',
      'supplierDocNumber',
      'supplierDocDate',
      'supplierDocAmount',
      'supplierDocUrl',
    ];

    if (!customerCreditNoteAvailable && !refundInitiated) return true;
    if (customerCreditNoteAvailable && !validateInputs(creditNoteKeys, values, errors)) return true;
    if (refundInitiated && !validateInputs(refundKeys, values, errors)) return true;
    if (supplierDocAvailable && !validateInputs(supplierDocKeys, values, errors)) return true;
    return false;
  };
  const onSubmitForm = (values, { resetForm }) => {
    resetForm({ values: initialValues });
    setIssueResolutionModalVisible(!issueResolutionModalVisible);

    const inputs = {
      ...values,
      resolvedAt: getFormattedTimestamp(),
      issueStatus: ISSUE_STATUS.REFUND_ISSUED,
      issueData: { ...record },
      creditNoteDate: formatToDateOnly(values.creditNoteDate),
      supplierDocDate: formatToDateOnly(values.supplierDocDate),
      refundDate: formatToDateOnly(values.refundDate),
    };
    updateIssueStatus(inputs)
    .then((res) => {
      if (res.success) {
        setToastText('Resolution details submitted successfully!');
        setToastVisible(true);
      }
    });
  };

  const paymentModes = [
    { label: 'Bank Transfer', value: 'Bank Transfer' },
    { label: 'NEFT', value: 'NEFT' },
    { label: 'Cheque', value: 'Cheque' },
    { label: 'UPI', value: 'UPI' },
  ];

  const supplierDocOptions = [
    { id: '1', name: 'Credit Note' },
    { id: '2', name: 'Debit Note' },
  ];

  return (
    <Modal
      title={
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
          {/* Issue a refund */}
          {status === ISSUE_STATUS.RETURN_INITIATED
            ? 'Enter Resolution details'
            : 'No pickup required'}
        </span>
      }
      open={issueResolutionModalVisible}
      onCancel={() => setIssueResolutionModalVisible(!issueResolutionModalVisible)}
      footer={null}
      className="issue-refund-modal">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmitForm}
        validationSchema={validationSchema}>
        {({
          handleSubmit,
          touched,
          errors,
          dirty,
          values,
          setFieldValue,
          isValid,
          validateForm,
        }) => {
          return (
            <div className="scrollable-content">
              <Form className={style.form}>
                <div className="modal-container">
                  <div className={style['toggle-button-container']}>
                    {showWarning ? (
                      <div className={style['messageCont']}>
                        <img src={AlertImg} style={{ height: 25 }} />
                        <p className={style['messageTxt']}>
                          {' '}
                          {`You’ve already initiated a ${
                            customerCreditNoteAvailable ? 'credit note' : 'refund'
                          }. To proceed 
                      with a ${
                        !customerCreditNoteAvailable ? 'credit note' : 'refund'
                      }, please cancel the ${
                        customerCreditNoteAvailable ? 'credit note' : 'refund'
                      } first.`}
                        </p>
                      </div>
                    ) : null}
                    <StatusToggler
                      label={'Is any credit note issued to customer?'}
                      style={style}
                      onFalseLabel={customerCreditNoteAvailable ? 'Yes  ' : 'No  '}
                      onTrueLabel={''}
                      condition={customerCreditNoteAvailable}
                      onChange={(e) => {
                        if (refundInitiated) {
                          setShowWarning(true);
                          return;
                        }
                        setShowWarning(false);
                        setCutomerCreditNoteAvailable(!customerCreditNoteAvailable);
                        setFieldValue('customerCreditNoteAvailable', !customerCreditNoteAvailable);

                        if (!customerCreditNoteAvailable) {
                          setFieldValue('creditNoteNumber', null);
                          setFieldValue('creditNoteDate', null);
                          setFieldValue('creditNoteAmount', null);
                          setFieldValue('creditNote', null);
                          setFieldValue('creditNoteUrl', null);
                        }
                      }}
                    />
                  </div>
                  {customerCreditNoteAvailable && (
                    <>
                      <FieldInput
                        isRequired
                        name="creditNoteNumber"
                        label="Credit note number"
                        placeholder="Enter credit note number"
                        type="text"
                      />

                      <DateFieldInput
                        isRequired={true}
                        name="creditNoteDate"
                        label="Credit note date"
                        placeholder="Select date"
                      />

                      <FieldInput
                        isRequired
                        name="creditNoteAmount"
                        label="Credit note amount"
                        placeholder="Enter credit note amount"
                        isPrice={true}
                        type="number"
                      />

                      <FileInput
                        uploadButtonName="Credit note"
                        name="creditNoteUrl"
                        label="Attach credit note"
                        isRequired={true}
                        resetUpload={!values['creditNoteUrl']}
                        acceptFileType=".pdf"
                      />
                    </>
                  )}

                  <div className={style['toggle-button-container']}>
                    <StatusToggler
                      label={"Have you initiated this refund to the customer's account?"}
                      style={style}
                      onFalseLabel={refundInitiated ? 'Yes  ' : 'No  '}
                      onTrueLabel={''}
                      condition={refundInitiated}
                      onChange={(e) => {
                        if (customerCreditNoteAvailable) {
                          setShowWarning(true);
                          return;
                        }
                        setShowWarning(false);
                        setRefundInitiated(!refundInitiated);
                        setFieldValue('refundInitiated', !refundInitiated);

                        if (!refundInitiated) {
                          setFieldValue('paymentMode', null);
                          setFieldValue('refundDate', null);
                          setFieldValue('refundAmount', null);
                          setFieldValue('utrRefNumber', null);
                          setFieldValue('refundDocUrl', null);
                        }
                      }}
                    />
                  </div>

                  {refundInitiated && (
                    <>
                      <SelectInput
                        name="paymentMode"
                        label="Mode of payment"
                        placeholder="Select"
                        isRequired={true}
                        options={paymentModes}
                      />

                      <DateFieldInput
                        isRequired={true}
                        name="refundDate"
                        label="Refund date"
                        placeholder="Select date"
                      />

                      <FieldInput
                        isRequired
                        name="refundAmount"
                        label="Refund Amount"
                        placeholder="Enter refund amount"
                        isPrice={true}
                        type="number"
                      />

                      <FieldInput
                        isRequired
                        name="utrRefNumber"
                        label="UTR / Reference Number"
                        placeholder="Enter reference number"
                        type="text"
                      />

                      <FileInput
                        uploadButtonName="Attach file"
                        name="refundDocUrl"
                        label="Supporting Document"
                        isRequired={true}
                        resetUpload={!values['refundDocUrl']}
                      />
                    </>
                  )}

                  <div className={style['toggle-button-container']}>
                    <StatusToggler
                      label={'Supplier document available?'}
                      style={style}
                      onFalseLabel={supplierDocAvailable ? 'Yes  ' : 'No  '}
                      onTrueLabel={''}
                      condition={supplierDocAvailable}
                      onChange={(e) => {
                        setSupplierDocAvailable(!supplierDocAvailable);
                        setFieldValue('supplierDocAvailable', !supplierDocAvailable);

                        if (!supplierDocAvailable) {
                          setFieldValue('supplierDocType', null);
                          setFieldValue('supplierDocNumber', null);
                          setFieldValue('supplierDocAmount', null);
                          setFieldValue('supplierDocDate', null);
                          setFieldValue('supplierDocUrl', null);
                        }
                      }}
                    />
                  </div>

                  {supplierDocAvailable && (
                    <>
                      <div className={`${style['data-container']} mt-2 mb-4`}>
                        {(() => {
                          const isReturn = record?.issueStatus === ISSUE_STATUS.RETURN_INITIATED;
                          const supplierNames =
                            record.supplierName?.split(',').map((s) => s.trim()) || [];
                          const supplierIds =
                            record.supplierId?.split(',').map((s) => s.trim()) || [];

                          const supplierOptions =
                            supplierNames.length === supplierIds.length
                              ? supplierNames.map((name, index) => ({
                                  label: name,
                                  value: supplierIds[index],
                                }))
                              : [];
                          return (
                            <>
                              <span
                                className={`${style['grey-text']} ${style['wt-600']}`}
                                style={{ width: '50%' }}>
                                Supplier Name
                              </span>
                              {supplierOptions.length > 1 ? (
                                !isReturn ? (
                                  <SelectInput
                                    name="supplierId"
                                    label=""
                                    placeholder="Select supplier"
                                    options={supplierOptions}
                                  />
                                ) : (
                                  <span className={`${style['black-text']} ${style['wt-600']}`}>
                                    {supplierOptions[1]?.label || ''}
                                  </span>
                                )
                              ) : (
                                <span className={`${style['black-text']} ${style['wt-600']}`}>
                                  {supplierOptions[0]?.label || ''}
                                </span>
                              )}
                            </>
                          );
                        })()}
                      </div>

                      <div className="mt-4">
                        <RadioFieldInput
                          name="supplierDocType"
                          label="Document type"
                          isRequired
                          options={supplierDocOptions}
                          onSelect={(value) => {
                            setFieldValue('supplierDocType', value);
                            const docType = supplierDocOptions.find((item) => item.id === value);
                            setSupplierDocLabel(docType['name']);
                          }}
                          isMultipleAllowed={false}
                        />
                      </div>

                      <FieldInput
                        isRequired
                        name="supplierDocNumber"
                        label={`${supplierDocLabel} number`}
                        placeholder={`Enter ${supplierDocLabel} number`}
                        type="text"
                      />

                      <DateFieldInput
                        isRequired={true}
                        name="supplierDocDate"
                        label={`${supplierDocLabel} date`}
                        placeholder="Select date"
                      />

                      <FieldInput
                        isRequired
                        name="supplierDocAmount"
                        label={`${supplierDocLabel} amount`}
                        placeholder={`Enter ${supplierDocLabel} amount`}
                        isPrice={true}
                        type="number"
                      />

                      <FileInput
                        uploadButtonName={`${supplierDocLabel}`}
                        name="supplierDocUrl"
                        label={`Attach ${supplierDocLabel}`}
                        isRequired={true}
                        resetUpload={!values['supplierDocUrl']}
                      />
                    </>
                  )}
                </div>
              </Form>

              <div className="modal-footer">
                <button
                  type="button"
                  className="close-btn"
                  onClick={() => setIssueResolutionModalVisible(false)}>
                  Close
                </button>
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={disableSubmitButton(values, errors)}
                  onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          );
        }}
      </Formik>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  activeIssueData: state.issuePanelData.activeIssueData,
});

const mapDispatchToProps = (dispatch) => ({
  updateIssueStatus: (data) => dispatch(updateIssueStatus(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IssueResolutionModal);
